import React, { Component} from "react";
import { withRouter, Link } from "react-router-dom";
import {hot} from "react-hot-loader";
import axios from 'axios';
import {Footer, Header, LastSection} from "../components";
import { FAQ_SHOW_ALL_URL } from "../constants/path";
import {
	faq,
	next,
	payment_and_purchase,
	receive,
	reports,
	calender,
	functions,
	setting,
	_else,
	skyscrapers,
	maintenance,
	payroll,
	profileSetting,
	services
} from "../images";

class FaqListPage extends Component{

	constructor() {
		super();
		this.state = {
			lists: []
		}
	}
	componentDidMount() {
		window.scrollTo(0,0);
		const imageName = { faq, next, payment_and_purchase,  receive,  reports,  calender, functions,  setting, _else, skyscrapers, maintenance, payroll, profileSetting, services  };
		axios.get(FAQ_SHOW_ALL_URL)
			.then(resulte => {
				// return resulte.json();
				return resulte.data;
			}).then(data => {
				let lists = data.faq.map((items) => {
					return (
						<div className="container direction-rtl step-two-container" key={items.id}>
							<div className="row step-by-step-lists-header-border-bottom">
								<div className="col-12">
									<div className="row">
										<div className="col-10 text-right step-by-step-lists-header-title-container">
											<span className="step-by-step-lists-header-title">{items.title}</span>
										</div>
										<div className="col-2 text-left step-by-step-lists-header-icon-container">
											<img className="step-by-step-lists-header-icon" src={imageName[items.icon]} title="پرداخت و خرید" alt="پرداخت و خرید"/>
										</div>
									</div>
								</div>
							</div>
							<div className="row mb-5 pb-4 step-by-step-list-page-sub-item-row-container">
								{
									items.questions.map((subItems) => {
										return (
											<div className="col-12 mt-3 border-bottom-faq step-by-step-list-page-sub-item-main-col-container" key={subItems.id}>
												<div className="row">
													<div className="col-10 text-right step-by-step-lists-header-title-container">
														<Link className="step-by-step-list-page-sub-item" to={{ pathname: `${subItems.link}`, state: { question: subItems.question, answer: subItems.answer }}} >{subItems.question}</Link>
													</div>
													<div className="col-2 text-left step-by-step-lists-header-icon-container">
														<Link className="step-by-step-list-page-sub-item" to={{ pathname: `${subItems.link}`}}>
															<img className="next" src={next} alt={subItems.question} title={subItems.question}/>
														</Link>
													</div>
												</div>
											</div>
										);
									})
								}
							</div>
						</div>
					);
				});
				this.setState( {lists: lists} );
		});
	}
	render () {
		return(
			<div>
				<Header />
				{this.state.lists}
				<LastSection/>
				<Footer />
			</div>
		);
	}
}

export default withRouter(hot(module)(FaqListPage));